/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Password_MismatchInputs */



/**
* | output |
* | --- |
* | "Passwords do not match" |
*
* @param {Login_Error_Password_MismatchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_password_mismatch = /** @type {((inputs?: Login_Error_Password_MismatchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Password_MismatchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les mots de passe ne correspondent pas")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Passwörter stimmen nicht überein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le password non corrispondono")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пароли не совпадают")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las contraseñas no coinciden")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("密码不匹配")
	if (locale === "ja") return /** @type {LocalizedString} */ ("パスワードが一致しません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सांकेतिक शब्द मेल नहीं खाते")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("As senhas não coincidem.")
	return /** @type {LocalizedString} */ ("Passwords do not match")
});